import { useEffect, useState } from "react"

import type { PortalTypeForContext } from "~contexts/outfitter-provider"
import { useUser } from "~contexts/user-provider"
import type { PortalEntitiesQuery } from "~graphql/dashboard.generated"
import { usePortalEntitiesQuery } from "~graphql/dashboard.generated"

export default function usePortalEntities({
    adminSearchText,
    portalType,
}: {
    adminSearchText?: string
    portalType?: PortalTypeForContext
} = {}) {
    const [data, setData] = useState<PortalEntitiesQuery | null>(null)

    const { isAdminNotImpersonating } = useUser()
    const adminSearch = getAdminSearchArg({
        isAdminNotImpersonating,
        adminSearchText,
        portalType,
    })
    const {
        data: queryData,
        loading: isLoading,
        error,
    } = usePortalEntitiesQuery({
        variables: { adminSearch },
        notifyOnNetworkStatusChange: true,
    })

    useEffect(() => {
        if (queryData) setData(queryData)
    }, [queryData])

    const portalTypes = data?.portalEntities.portal_types ?? []
    const outfitters = data?.portalEntities.outfitters ?? []
    const eventOrganizers = data?.portalEntities.event_organizers ?? []
    const defaultPortalType = portalTypes[0] ?? null
    const defaultOutfitter = outfitters[0] ?? null
    const defaultEventOrganizer = eventOrganizers[0] ?? null

    return {
        defaultPortalType,
        portalTypes,
        outfitters,
        eventOrganizers,
        defaultOutfitter,
        defaultEventOrganizer,
        isLoading,
        error,
    }
}

function getAdminSearchArg({
    isAdminNotImpersonating,
    adminSearchText,
    portalType,
}: {
    isAdminNotImpersonating: boolean
    adminSearchText?: string
    portalType?: PortalTypeForContext
}) {
    if (!isAdminNotImpersonating || !adminSearchText || !portalType) return null

    return {
        searchText: adminSearchText,
        portalType,
        paging: { page: 0, size: 10 },
    }
}
